import script from "./SliderPropsComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SliderPropsComponent.vue?vue&type=script&setup=true&lang=ts"

import "./SliderPropsComponent.vue?vue&type=style&index=0&id=dbf1b804&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dbf1b804"]])

export default __exports__